export const PAYMENT_STATUS_STYLES = {
  paid: { label: 'Paid', className: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
  partial: { label: 'Partial', className: 'bg-amber-100 text-amber-700 border-amber-300' },
  unpaid: { label: 'Unpaid', className: 'bg-red-100 text-red-700 border-red-300' },
};

export const paymentBadge = (status) => PAYMENT_STATUS_STYLES[status] || PAYMENT_STATUS_STYLES.unpaid;
